import { lazy } from "react";
export var LazyAppModals = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "retailer-app-modals" */ "./AppModals").then(function(m) {
        return {
            default: m.AppModals
        };
    });
});
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
LazyAppModals.preload = function() {
    return import(/* webpackChunkName: "retailer-app-modals" */ "./AppModals").then(function(m) {
        return {
            default: m.AppModals
        };
    });
};
